import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

const SIDEBAR_COOKIE_NAME = 'sidebar_state'

interface SidebarStore {
    open: boolean
    openMobile: boolean
    setOpen: (open: boolean) => void
    setOpenMobile: (open: boolean) => void
    toggleSidebar: () => void
}

export const useSidebarStore = create<SidebarStore>()(
    persist(
        (set, get) => ({
            open: true,
            openMobile: false,
            setOpen: (open: boolean) => set({ open }),
            setOpenMobile: (openMobile: boolean) => set({ openMobile }),
            toggleSidebar: () => {
                const { open, openMobile } = get()
                // We need to know if we are mobile or not, but the store itself doesn't know about window width
                // The toggle logic in the component relied on `useIsMobile`. 
                // Here, we can perhaps just have two toggle actions or let the caller decide.
                // However, preserving the existing API `toggleSidebar` which checks mobile state inside might be tricky without passing `isMobile` to it.
                // Let's change the API slightly: `toggleSidebar` in the component will check `isMobile`.
                // Or, we can store `isMobile` in the store, but that requires a listener.
                // Simpler: The component will call `setOpen(!open)` or `setOpenMobile(!openMobile)` based on `isMobile`.
                set({ open: !open }) 
            }
        }),
        {
            name: SIDEBAR_COOKIE_NAME,
            storage: createJSONStorage(() => localStorage), // Using localStorage for simplicity, or we can use cookies if SSR is needed
        }
    )
)
